/* eslint-disable @typescript-eslint/naming-convention */
import {
  GetSkuRegistrationListResponseType,
  GetCreatorsSkuRegistrationResponseType,
  GetAllConstantType,
  SkuRegistrationItemType,
} from 'features/Product/@types/SkuRegistration'

import axiosInstanceApiGateway from 'config/apiServiceApiGateway'

export type GetSkuRegistrationListParamsType = {
  'pagination.page_index': number
  'pagination.page_size': number
  'pagination.direction': 'asc' | 'desc'
  'filter.sku_number'?: string
  'filter.statuses'?: string
  'filter.date_from'?: Nullable<string>
  'filter.date_to'?: Nullable<string>
  'filter.l1_category_id'?: Nullable<number>
  'filter.l2_category_id'?: Nullable<number>
  'filter.creator_id'?: Nullable<number>
}

export type GetSkuRegistrationCreatorListParamsType = {
  page_index: number
  page_size: number
  name?: string
}

export const getSkuRegistrationList = (params: GetSkuRegistrationListParamsType) =>
  axiosInstanceApiGateway.Get<GetSkuRegistrationListResponseType, true>({
    url: `/wims/internal/v1/products/registrations`,
    params,
  })

export const getSkuRegistrationCreatorList = (params: GetSkuRegistrationCreatorListParamsType) =>
  axiosInstanceApiGateway.Get<GetCreatorsSkuRegistrationResponseType, true>({
    url: '/accounts/internal/v2/user',
    params,
  })

export const getSkuRegistrationDetail = (id: string) =>
  axiosInstanceApiGateway.Get<{ data: SkuRegistrationItemType }, true>({
    url: `/wims/internal/v1/products/registrations/${id}`,
  })

export const getAllConstant = () =>
  axiosInstanceApiGateway.Get<GetAllConstantType>({ url: `/wims/internal/v1/constants` })

export const submitProductRegistration = (id: string, data: SkuRegistrationItemType) =>
  axiosInstanceApiGateway.Put({
    url: `/wims/internal/v1/products/registrations/${id}/submit`,
    data,
  })

export const cancelSkuRegistration = (id: string) =>
  axiosInstanceApiGateway.Put({
    url: `/wims/internal/v1/products/registrations/${id}/cancel`,
  })

export const rejectSkuRegistration = (id: string, data: SkuRegistrationItemType) =>
  axiosInstanceApiGateway.Put({
    url: `/wims/internal/v1/products/registrations/${id}/reject`,
    data,
  })

export const approveSkuRegistration = (id: string) =>
  axiosInstanceApiGateway.Put({
    url: `/wims/internal/v1/products/registrations/${id}/approve`,
  })
